import axios from 'axios';

// Create axios instance with default config
const instance = axios.create({
  baseURL: 'https://api.kewaar.com/api',
  withCredentials: true,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json'
  }
});

// Add a request interceptor
instance.interceptors.request.use(
  config => {
    // You can add any auth tokens here if needed
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// Add a response interceptor
instance.interceptors.response.use(
  response => response,
  async error => {
    if (error.response?.status === 405) {
      // Method not allowed, try to convert PATCH to POST
      const originalRequest = error.config;
      if (originalRequest.method === 'patch') {
        originalRequest.method = 'post';
        originalRequest.headers['X-HTTP-Method-Override'] = 'PATCH';
        return instance(originalRequest);
      }
    }
    return Promise.reject(error);
  }
);

export default instance; 